import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GuardService } from '../auth/guard.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Account, ROLE, ROLE_NAME } from '../../../model/account.model';
import { AccountService } from '../../ServiceEntity/account.service';
import { ROUTE_HOME_, ROUTE_HOME_FULL } from '../../../layout/components/home.route';
import { Url } from '../../../shared/constant/url.constant';
import ERR_404 = Url.ERR_404;
import { GuardAuthoritiesService } from './guard-authorities.service';

/**
 * Permet de vérifier si un utilisateur possède le role
 * {@link ROLE.partener} afin de pouvoir décider
 * si on lui donne accès à la route.
 */
@Injectable({
  providedIn: 'root'
})
export class GuardAdminService implements CanActivate {
  constructor(
    private router: Router,
    private guardAuthoritiesService: GuardAuthoritiesService
  ) {

  }

  /**
   * Si l'utilisateur possède le role {@link ROLE.admin}
   * alors on lui donne accès à la route.
   * @param route
   * @param state
   * @Return true si l'utilisateur possède le role {@link ROLE.partener} ,
   * false dans le cas contraire et il sera redirigé
   * vers la page d'erreur.
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('## verify admin role');
    return this.guardAuthoritiesService.hasRole(route, state, ROLE.admin);
  }

}
